// Import JS Modules
import flatMap from 'lodash/flatMap';
import uniqBy from 'lodash.uniqby';
// Import JSX Modules
import DeliveryOptionCalculator from '../_delivery-options/calculator';
import OrderCalculator from './order-calculator';

export default {
  unknownDeliveryGroupKey: '-UNKNOWN-', // usually when a DeliveryOption has no `type`

  groupedByDeliveryOptionType({ prints, prismItems }) {
    const groups = new Map();

    if (OrderCalculator.somePrints(prints)) {
      addToDeliveryTypeGroup.call(this, prints);
    }

    prismItems.forEach(addToDeliveryTypeGroup, this);

    if (
      groups.get(this.unknownDeliveryGroupKey) &&
      groups.get(this.unknownDeliveryGroupKey).size === 0
    ) {
      groups.delete(this.unknownDeliveryGroupKey);
    }

    return groups;

    function addToDeliveryTypeGroup(item) {
      const deliveryOption = (item.delivery_options || []).find(
          option => option.key === item.delivery
        ),
        deliveryType =
          DeliveryOptionCalculator.deliveryOptionType(deliveryOption) ||
          this.unknownDeliveryGroupKey;

      groups.has(deliveryType) ||
        groups.set(deliveryType, {
          group: deliveryOption,
          items: new Set(),
        });
      groups.get(deliveryType).items.add(item);
    }
  },

  groupedByDeliveryOption(itemSet) {
    const groups = new Map();

    itemSet.forEach(addToDeliveryOptionGroup);

    return groups;

    function addToDeliveryOptionGroup(item) {
      const deliveryOption = (item.delivery_options || []).find(
          option => option.key === item.delivery
        ),
        key = item.delivery;

      groups.has(key) ||
        groups.set(key, {
          group: deliveryOption,
          items: new Set(),
        });
      groups.get(key).items.add(item);
    }
  },

  selectedDeliveryOption({ delivery: id, delivery_options: deliveryOptions }) {
    return id && (deliveryOptions || []).find(option => option.key == id);
  },

  hasDeliveryOptionType({ prints, prismItems }, deliveryOptionTypes) {
    const alivePrints = OrderCalculator.alivePrints(prints);
    const alivePrismItems = OrderCalculator.alivePrismItems(prismItems);

    deliveryOptionTypes = [].concat(deliveryOptionTypes);

    const deliveryOptionTypesMap = this.groupedByDeliveryOptionType({
      prints: alivePrints,
      prismItems: alivePrismItems,
    });

    return deliveryOptionTypes.some(deliveryOptionType =>
      deliveryOptionTypesMap.has(deliveryOptionType)
    );
  },

  hasDeliveryOptionTypeOtherThan({ prints, prismItems }, deliveryOptionTypes) {
    deliveryOptionTypes = []
      .concat(deliveryOptionTypes)
      .reduce(function(acc, deliveryOptionType) {
        acc[deliveryOptionType] = true;
        return acc;
      }, {});

    const deliveryOptionTypesMap = this.groupedByDeliveryOptionType({
      prints,
      prismItems,
    });

    return [...deliveryOptionTypesMap.keys()].some(
      deliveryOptionType => !deliveryOptionTypes[deliveryOptionType]
    );
  },

  hasMultipleAvailableDeliveryOptions({ prints, prismItems }) {
    return this.availableDeliveryOptions({ prints, prismItems }).length > 1;
  },

  hasMultipleSelectedDeliveryOptions({ prints, prismItems }) {
    return (
      this.selectedDeliveryOptions({ prints, prismItems }, { noFilter: true })
        .length > 1
    );
  },

  availableDeliveryOptions({ prints, prismItems }) {
    const items = []
      .concat(
        OrderCalculator.alivePrints(prints),
        OrderCalculator.alivePrismItems(prismItems)
      )
      .filter(Boolean);

    const deliveryOptions = flatMap(items, extractDeliveryOptions);

    return uniqBy(deliveryOptions, 'key').sort(
      (a, b) => a.sort_order - b.sort_order
    );

    function extractDeliveryOptions(item) {
      return (item || {}).delivery_options || [];
    }
  },

  selectedDeliveryOptions({ prints, prismItems }, options = {}) {
    const items = []
      .concat(
        OrderCalculator.alivePrints(prints),
        OrderCalculator.alivePrismItems(prismItems)
      )
      .filter(Boolean);

    let deliveryOptions = items.map(this.selectedDeliveryOption);

    if (!options.noFilter) {
      // filtering is on unless otherwise set via { noFilter: true }
      deliveryOptions = deliveryOptions.filter(Boolean);
    }

    return uniqBy(deliveryOptions, 'key').sort(
      (a, b) => a.sort_order - b.sort_order
    );
  },
};
